// extracted by mini-css-extract-plugin
export default {"container":"db_title_container__+74RP","title":"db_title_title__ezhp7","title_box":"db_title_title_box__AinHz","actions":"db_title_actions__BKvHy"};